export default __webpack_public_path__ + "static/media/Project-1-SingleProject-MobileDisplay.1d6c3a0a.png";